export default "__VITE_ASSET__N6XIp1sV__"